import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const CalendarToolbar = ({ title, mode, onToday, onShift, children }) => {
    const unit = mode === 'week' ? 'week' : 'month';
    return (
        <div className="cal-toolbar">
            <div className="toolbar-left">
                <button type="button" className="today-btn" onClick={onToday}>Today</button>
                <button type="button" className="nav-btn" aria-label={`Previous ${unit}`} onClick={() => onShift(-1)}>
                    <FiChevronLeft aria-hidden="true" />
                </button>
                <button type="button" className="nav-btn" aria-label={`Next ${unit}`} onClick={() => onShift(1)}>
                    <FiChevronRight aria-hidden="true" />
                </button>
                <h2>{title}</h2>
            </div>
            <div className="toolbar-right">{children}</div>
        </div>
    );
};

export default CalendarToolbar;
